(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('EditTagController', EditTagController);

    EditTagController.$inject = ['$state', 'TestSettingTag', 'AlertService', '$uibModal', 'Principal'];

    function EditTagController($state, TestSettingTag, AlertService, $uibModal, Principal) {
        var vm = this;

        vm.tags = [];
        vm.editorEnabled = [];
        vm.updateDescription = [];

        vm.loadAll = function () {
            Principal.hasAuthority("ROLE_ADMIN").then(function (isAdmin){
                if(isAdmin) {
                    TestSettingTag.byDomain({size: 1000}, function (result) {
                        vm.tags = result;
                    })
                } else {
                    TestSettingTag.customByDomain({size: 1000}, function (result) {
                        vm.tags = result;
                    })
                }
            });
        }

        vm.enableEditor = function(index, edit) {
            if(edit === 0) {
                if(!vm.editorEnabled[index]) {
                    vm.editorEnabled[index] = true;
                    if(vm.updateDescription[index] === undefined)
                        vm.updateDescription[index] = vm.tags[index].testTag;
                }
            } else if(edit === 1) {
                vm.editorEnabled[index] = !vm.editorEnabled[index];
                vm.updateDescription[index] = vm.tags[index].testTag;
            } else {
                vm.editorEnabled[index] = !vm.editorEnabled[index];
                vm.updateDescription[index] = vm.tags[index].testTag;
            }
        };

        vm.saveUpdate = function(index) {
            vm.tags[index].testTag = vm.updateDescription[index].toUpperCase();

            TestSettingTag.update(vm.tags[index], onSuccess, onError);

            function onSuccess() {
                vm.editorEnabled[index] = !vm.editorEnabled[index];
            }

            function onError(){
                AlertService.error("Cannot edit this tag");
            }
        };

        vm.loadAll();

        vm.newTag = function () {
            $uibModal.open({
                templateUrl: 'app/entities/object-test-setting/new-tag.html',
                controller: 'NewTagController',
                controllerAs: 'vm',
                size: 'md',
            }).result.then(function () {
                $state.reload();
            });
        };
    }
})();
